import React from "react";
import TradeHistory from "../../components/Analysis/TradeHistory/TradeHistory";
import CloseTrades from "../../components/AccountMetrics/CloseTrades";
import AccountMetricsHeader from "../../components/AccountMetricsHeader";
import { useSelector } from "react-redux";
import BackButton from "../../reusableComponents/BackButton/BackButton";
import { useNavigate, useLocation } from "react-router-dom";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
import "./Trading.scss";

const Trading = () => {
  const { data, isLoading, error } = useSelector(
    (state) => state?.accountMetrics
  );

  const navigate = useNavigate();
  const location = useLocation();

  const handleRedirectLink = (path) => {
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
    }
  };

  const resetAccount = (loginId) => {
    // Handle reset account functionality
    console.log("Reset account:", loginId);
  };

  return (
    <div className="trading-history">
      {isLoading && <LoaderOverlay />}
      <AccountMetricsHeader onResetAccount={resetAccount} />
      <BackButton onClick={() => handleRedirectLink("/account-stats")} />
      <CloseTrades data={data || null} />
    </div>
  );
};

export default Trading;
